<template>
    <a :href="href" class="flex items-center justify-center text-button px-4 py-[9px]" :class="{ 'hover:[text-shadow:_0_0_37px_rgba(158,252,78,0.59)]': type === 'inverse'}">
        <slot name="icon-before" />
        <slot />
        <slot name="icon-after" />
    </a>
</template>

<script>
export default {
    props: {
        href: {
            type: String,
            default: ''
        },
        type: {
          type: String,
          default: 'default'
        }
    }
}
</script>

<style>

</style>
